var AppointmentsCardDataTestId = /* @__PURE__ */ ((AppointmentsCardDataTestId2) => {
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_SCHEDULED"] = "appointments--card-scheduled";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_FLEX"] = "appointments--card-flex";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_TELEMED"] = "appointments--card-telemed";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_LAB"] = "appointments--card-lab";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_STANDALONE"] = "appointments--card-standalone";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_ARRIVAL_ORDER"] = "appointments--card-arrival-order";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_FLEX_SUPPORT"] = "appointments--card-flex-support";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_TELEMED_SUPPORT"] = "appointments--card-telemed-support";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_STANDALONE_SUPPORT"] = "appointments--card-standalone-support";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_EXPORT_GUIDE"] = "appointments--card-export-guide";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_PHONE_UPDATE_BUTTON"] = "appointments--card-phone-update-button";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_PHONE_UPDATE_SUBMIT"] = "appointments--card-phone-update-submit";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_TOGGLE_DETAILS"] = "appointments--card-toggle-details";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_EDIT_DATE"] = "appointments--card-edit-date";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_EDIT_PATIENT"] = "appointments--card-edit-patient";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_PROCEDURES"] = "card-appointment--procedures";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_DATE_TIME"] = "card-appointment--date-time";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_GUIDE_CODE"] = "card-appointment--guide-code";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_LOCATION"] = "card-appointment--location";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_PATIENT"] = "card-appointment--patient";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_PREPARE"] = "card-appointment--prepare";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_PAYMENT"] = "card-appointment--payment";
  AppointmentsCardDataTestId2["APPOINTMENT_CARD_ALERT"] = "card-appointment--alert";
  return AppointmentsCardDataTestId2;
})(AppointmentsCardDataTestId || {});
export {
  AppointmentsCardDataTestId
};
